/** @format */

import {
    SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC,
    SUBSTRATE_SILVER_METALLIC_PLASTIC,
    SUBSTRATE_SILVER_METALLIC_PAPER,
    SUBSTRATE_ULTRA_CLEAR_PLASTIC,
    SUBSTRATE_CLEAR_PLASTIC,
    SUBSTRATE_BLACK_VELLUM,
    SUBSTRATE_KRAFT_PAPER,
    SUBSTRATE_CLEAR_VINYL
} from 'frontier-constants';
import React from 'react';

export const SpotwhiteNotice = ({substrateId}) => {
    let notice = `Magenta areas indicate where spotwhite will be printed under
    your artwork. White areas `;

    switch (substrateId) {
        case SUBSTRATE_ULTRA_CLEAR_PLASTIC:
        case SUBSTRATE_CLEAR_PLASTIC:
        case SUBSTRATE_CLEAR_VINYL:
            notice = notice + 'will be clear or transparent colors';
            break;
        case SUBSTRATE_KRAFT_PAPER:
            notice = notice + 'will be plain kraft material';
            break;
        case SUBSTRATE_BLACK_VELLUM:
            notice = notice + 'will be plain black vellum material';
            break;
        case SUBSTRATE_SILVER_METALLIC_PAPER:
        case SUBSTRATE_SILVER_METALLIC_PLASTIC:
            notice = notice + 'will appear metallic';
            break;
        case SUBSTRATE_RAINBOW_HOLOGRAM_PLASTIC:
            notice = notice + 'will appear holographic';
            break;
        default:
            notice = notice + 'will not be opaque';
    }

    return <>{notice}</>;
};
